import type { IxfWatchlistV1Fincen314MatchKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const FINCEN_MATCH_BASE_PATH = getResolvedPath('/clearing/compliance/fincen/match');

export const getFincenMatchPath: EntityPathBuilder<IxfWatchlistV1Fincen314MatchKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return FINCEN_MATCH_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.fincen314MatchId) {
        return undefined;
      }

      return getResolvedPath(`${FINCEN_MATCH_BASE_PATH}/$fincen314MatchId`, context.keys);
    }
  }
};

export function getFincenMatchDetailPath(fincen314MatchId: string | undefined) {
  if (!fincen314MatchId) {
    return undefined;
  }

  return getFincenMatchPath({ kind: 'detail', keys: { fincen314MatchId } });
}
